import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: [...authRoles.hauling, ...authRoles.producer, ...authRoles.subAdmin, ...authRoles.processor], routes: [{ path: '/upload-download', component: FuseLoadable({ loader: () => import('./UploadDownloadApp') }) }] };

export default [Index];
